import Vue from 'vue'
import axios from 'axios';
import router from '../router'
import QS from 'qs';
import apiI18nText from './apiI18n.json';
import { handleDataAndSign } from "@/assets/scripts/handleDataAndSign";
// const baseURL = process.env.API_ROOT; // 分别在 dev.env 和 prod.env 中配置测试和线上url
const baseURL = '/api'; // 跨域情况下使用

let http = (axiosType, withCredentials, customBaseURL) => {
  let config = {
    baseURL: !customBaseURL ? baseURL : customBaseURL,
    withCredentials: withCredentials,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [data => QS.stringify(data)]
  };
  switch (axiosType) {
    case 'upload':
      config = {
        baseURL: baseURL,
        withCredentials: withCredentials,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };
      break;
    default:
      break;
  }
  return axios.create(config);
};

function apiAxios(method, url, params, response, succTips,
  axiosType = 'normal', withCredentials = true, customBaseURL = '') {

  switch (url) {
    case "/admin/access/groupList": {
      const groupList = sessionStorage.getItem('groupList');
      if (groupList) {
        response(JSON.parse(groupList));
        return;
      }
    } break;
    default:
      break;
  }

  return http(axiosType, withCredentials, customBaseURL)({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null
  }).then((res) => {
    if (res.status >= 200 && res.status < 300) {
      switch (res.data.status) {
        case 1: {
          response(res.data.data);
          succTips && Vue.prototype.msg({
            showClose: true,
            message: apiI18n(res.data.tips),
            type: 'success'
          });
        }
          return;
        case 100000002: {
          response(res.data.data);
        } return;
        case 10000000018: {
          response(res.data);
        } return;
        case 100000008:
        case 1000000013:
        case 1000000014:
        case 1000000015: {
          Vue.$cookies.keys().forEach(key => {
            if (key !== 'rtp' && key !== 'language') {
              Vue.$cookies.remove(key);
            }
          });
          setTimeout(() => {
            router.push({ path: "/login" });
          }, 1000);
        }
          break;
        case 888888888: {
          let count = Vue.$cookies.get("verify") ? Vue.$cookies.get("verify") : 0;
          Vue.$cookies.set("verify", parseInt(count) + 1, 60 * 60);
        }
          break;
        case 888888885: {
          Vue.$cookies.set("verify", res.data.data.error_num);
        }
          break;
        default:
          break;
      }
      Vue.prototype.$msg({ showClose: true, message: apiI18n(res.data.tips), type: 'warning' });
    } else {
      Vue.prototype.$msg({
        showClose: true,
        message: "请求返回错误!",
        type: 'error'
      });
    }
  }).catch(() => {
    // response(err.data);
  });
}

export default {
  get: (url, params, response, succTips = false, withCredentials = true) => {
    return apiAxios('GET', url, handleDataAndSign(url, params), response, succTips, 'normal', withCredentials);
  },
  post: (url, params, response, succTips = false, withCredentials = true, sn = '') => {
    return apiAxios('POST', url, handleDataAndSign(url, params, sn), response, succTips, 'normal', withCredentials);
  },
  put: (url, params, response, succTips = false, withCredentials = true) => {
    return apiAxios('PUT', url, handleDataAndSign(url, params), response, succTips, 'normal', withCredentials);
  },
  delete: (url, params, response, succTips = false, withCredentials = true) => {
    return apiAxios('DELETE', url, handleDataAndSign(url, params), response, succTips, 'normal', withCredentials);
  },
  upload: (url, params, progress, response, succTips = false, withCredentials = true) => {
    let formData = new FormData();
    console.log("params---->", params);
    formData.append('file', params.file, `chunk_${params.chunk_current}.${params.ext}`);
    delete params.file;
    let HDA = handleDataAndSign(url, params);
    for (let key in HDA) formData.set(key, HDA[key]);
    return axios.create({
      baseURL: baseURL,
      withCredentials: withCredentials,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      onUploadProgress: progress
    })({
      method: 'POST',
      url: url,
      data: formData
    }).then(res => {
      if (res.status >= 200 && res.status < 300) {
        switch (res.data.status) {
          case 1: {
            response(res.data.data);
            succTips && Vue.prototype.msg({
              showClose: true,
              message: apiI18n(res.data.tips),
              type: 'success'
            });
          }
            return;
          case 100000002: {
            response(res.data.data);
          }
            return;
          case 100000008:
          case 1000000013:
          case 1000000014:
          case 1000000015: {
            setTimeout(() => {
              router.push({ path: "/login" });
            }, 1000);
          }
            break;
          case 888888888: {
            let count = Vue.$cookies.get("verify") ? Vue.$cookies.get("verify") : 0;
            Vue.$cookies.set("verify", parseInt(count) + 1, 60 * 60);
          }
            break;
          case 888888885: {
            Vue.$cookies.set("verify", res.data.data.error_num);
          }
            break;
          default:
            break;
        }
        Vue.prototype.$msg({ showClose: true, message: apiI18n(res.data.tips), type: 'warning' });
      } else {
        Vue.prototype.$msg({
          showClose: true,
          message: "请求返回错误!",
          type: 'error'
        });
      }
    }).catch(() => {
      // response(err.data);
    });
  },
  postCustom: (url, params, response, succTips = false, withCredentials = true, customBaseURL) => {
    return apiAxios('POST', url, handleDataAndSign(url, params), response, succTips, 'normal', withCredentials, customBaseURL);
  },
  postPromise: (url, params, response, withCredentials = true, customBaseURL) => {
    return http('POST', withCredentials, customBaseURL)({
      method: 'POST',
      url: url,
      data: params
    })
  }
}

// api请求方法使用
// this.$api.post("/admin/access/groupList", {}, data => {
//  console.log(data);
// });

function apiI18n(val) {
  const language = Vue.$cookies.get("language");
  let i18n = apiI18nText.find(t => t.zh.trim() === val.trim());
  console.log(language, i18n)
  if (i18n && language) {
    return i18n[language];
  } else {
    return val;
  }
}
